import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Drawer, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProductCatalogFilters from './ProductCatalogFilters';

interface ProductCatalogFilterDrawerProps {
  open: boolean
  onClose: () => void
}

export default function ProductCatalogFilterDrawer(props: ProductCatalogFilterDrawerProps) {
  const [t] = useTranslation('products');
  const theme = useTheme();
  const breakpointSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const mobileSheetPaperSx = {
    width: '100%',
    height: 'min(86dvh, calc(100dvh - 52px))',
    maxHeight: 'calc(100dvh - 52px)',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    backgroundColor: '#f0f0f0',
  };
  const drawerAnchor: 'bottom' | 'right' = breakpointSmDown ? 'bottom' : 'right';
  const drawerPaperSx = breakpointSmDown
    ? mobileSheetPaperSx
    : {
      width: 420,
      top: {
        xs: '52px',
        md: '64px',
      },
      height: {
        xs: 'calc(100dvh - 52px)',
        md: 'calc(100dvh - 64px)',
      },
      maxWidth: '100vw',
      backgroundColor: '#f0f0f0',
    };

  return <Drawer
    anchor={drawerAnchor}
    open={props.open}
    onClose={props.onClose}
    ModalProps={{
      keepMounted: true,
      sx: {
        zIndex: 1290,
      },
    }}
    PaperProps={{
      sx: drawerPaperSx,
    }}
  >
    <Stack sx={{ height: '100%' }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          px: 3,
          py: 2,
          borderBottom: '0.7px solid #afafaf',
        }}
      >
        <Typography variant="h3">{t('Filter by')}</Typography>
        <IconButton
          aria-label={t('Hide Filters')}
          edge="end"
          onClick={props.onClose}
        >
          <CloseRoundedIcon />
        </IconButton>
      </Stack>
      <Box
        component="div"
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          px: 3,
          py: 3,
        }}
      >
        <ProductCatalogFilters />
      </Box>
    </Stack>
  </Drawer>;
}
